import React from 'react';
import { ArcStack } from '@src/core/ui';
import { OrdersWrapperView, ToggleCollapseView } from '@src/features/order/pages/orders-page/components';
import { TakeOffSectionProps } from './types';
import { ArcOrderCard } from '@src/core/components';
import { OrderStatusEnum } from '@src/features/order/entities';
import { useNavigate } from 'react-router-dom';
import { buildConfirmOrderPath, ConfirmFlowOrigin } from '@src/features/order/navigation';

const TakeOffSection: React.FC<TakeOffSectionProps> = (props) => {
  const { orders, selected, count } = props;
  const navigate = useNavigate();
  return (
    <ArcStack direction='column' width='20%' height='100%' sx={{ display: 'flex', flexDirection: 'column' }}>
      <ToggleCollapseView 
        count={count}
        status={OrderStatusEnum.READY_FOR_TAKE_OFF}>
        <OrdersWrapperView>
          {orders.map((order, index) => (
            <ArcOrderCard
              key={order.missionId}
              order={order}
              fullWidth={false}
              isSelected={order.missionId === selected?.missionId}
              onClick={() => navigate(buildConfirmOrderPath(order.missionId, {
                origin: ConfirmFlowOrigin.ORDERS,
                droneSerial: order.drone.serialNumber,
              }))}
              index={index}
              status={OrderStatusEnum.READY_FOR_TAKE_OFF}
              sx={{ width: '100%', minHeight:'110px' }}
            />
          ))}
        </OrdersWrapperView>
      </ToggleCollapseView>
    </ArcStack>
  );
};

export default TakeOffSection;